module.exports = __webpack_public_path__ + "static/working.e2ca7c26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/working.jpg
// module id = 491
// module chunks = 35783957827783